import { render, staticRenderFns } from "./editGoogleAdFields.vue?vue&type=template&id=5d2cabbe&scoped=true&"
import script from "./editGoogleAdFields.vue?vue&type=script&lang=js&"
export * from "./editGoogleAdFields.vue?vue&type=script&lang=js&"
import style0 from "./editGoogleAdFields.vue?vue&type=style&index=0&id=5d2cabbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2cabbe",
  null
  
)

export default component.exports